"use client";

import React from "react";
import {
  wordpressDevelopmentHeroData,
  wordpressStatsData,
  wordpressSolutionsAndProcessData,
  wordpressTechnologiesData,
  wordpressAboutData,
  wordpressDevelopmentFaqs,
} from "src/utils/mock/wordpressDevelopmentData";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function WordpressDevelopmentComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const wordPressProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";

    const hasTrendingTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("wordpress"));

    return isActive && hasTrendingTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: wordPressProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={wordpressDevelopmentHeroData} />
      <TechStats stats={wordpressStatsData} />

      <WhyChooseUs data={wordpressSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={wordpressTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={wordpressAboutData} mainTitle="About WordPress Development" />
        </div>
      </section>
      <FAQSection faqs={wordpressDevelopmentFaqs} />
      <CommonContactSection />
    </div>
  );
}
